import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../utils/apiBase';

/**
 * One confirm step so email link scanners cannot opt someone out by opening the link.
 */
const ReviewOptOut: React.FC = () => {
  const { token = '' } = useParams<{ token: string }>();
  const [status, setStatus] = useState<'ready' | 'saving' | 'done' | 'error'>('ready');
  const [error, setError] = useState('');

  const confirm = async () => {
    setStatus('saving');
    setError('');
    try {
      const response = await fetch(`${API_BASE_URL}/public/reviews/opt-out/${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(body.error || 'This opt-out link is not valid.');
      }
      setStatus('done');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Something went wrong.');
      setStatus('error');
    }
  };

  return (
    <main
      className="review-opt-out"
      style={{
        minHeight: '70vh',
        background: '#f3eee6',
        color: '#1c1915',
        padding: '3rem 1.25rem',
      }}
    >
      <div
        style={{
          maxWidth: 520,
          margin: '0 auto',
          background: '#fbf8f3',
          border: '1px solid #e4d8c4',
          padding: '2.5rem 2rem',
          textAlign: 'center',
        }}
      >
        <img
          src="/brand/carmen-lorraine-mark.svg"
          width={56}
          height={56}
          alt=""
          style={{ display: 'block', margin: '0 auto 1rem' }}
        />
        <p
          style={{
            margin: 0,
            fontFamily: 'Inter, Helvetica, Arial, sans-serif',
            fontSize: 11,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
          }}
        >
          Carmen Lorraine Photography
        </p>
        <div style={{ borderBottom: '1px solid #c6a15b', margin: '1.25rem 0 1.75rem' }} />
        <h1
          style={{
            fontFamily: 'Georgia, "Times New Roman", serif',
            fontWeight: 400,
            fontSize: '1.75rem',
            margin: '0 0 1rem',
          }}
        >
          Review emails
        </h1>
        {status === 'done' ? (
          <p style={{ fontFamily: 'Georgia, serif', fontSize: '1.125rem', lineHeight: 1.55, margin: 0 }}>
            You will not receive further Google review emails from Carmen Lorraine Photography.
          </p>
        ) : (
          <>
            <p style={{ fontFamily: 'Georgia, serif', fontSize: '1.125rem', lineHeight: 1.55, margin: '0 0 1.5rem' }}>
              Prefer not to get emails asking for a Google review? Confirm below and we will stop sending them.
              This does not change anything else about your booking.
            </p>
            <button
              type="button"
              onClick={confirm}
              disabled={status === 'saving' || !token}
              style={{
                display: 'inline-block',
                background: '#1c1915',
                color: '#fbf8f3',
                border: 0,
                padding: '14px 22px',
                cursor: status === 'saving' ? 'wait' : 'pointer',
                fontFamily: 'Inter, Helvetica, Arial, sans-serif',
                fontSize: 14,
                letterSpacing: '0.04em',
              }}
            >
              {status === 'saving' ? 'Saving…' : 'Stop review emails'}
            </button>
            {error ? (
              <p role="alert" style={{ color: '#8f2d2d', marginTop: '1rem', fontFamily: 'Inter, sans-serif', fontSize: 14 }}>
                {error}
              </p>
            ) : null}
          </>
        )}
      </div>
    </main>
  );
};

export default ReviewOptOut;
